<template>

    <div class="absolute bottom-16 left-0 w-full p-2 px-4 bg-hh-cyan-300 border-4 border-b0 border-hh-grey-50 rounded cursor-pointer xl:hover:bg-hh-cyan-200 z-30"
         v-if="false && filters['place']"
         @click="togglePlaces"
    >
        <template v-if="arePlacesActive">
            {{ filters.country.translations['select-prov-reg'] }}
        </template>
        <template v-else>
            {{ filters.country.translations['select-place'] }}
        </template>
    </div>

    <div class="flex flex-col h-full">

        <div class="p-4 relative lg:hidden absolute">
            <filter-input-suggest
                :filter-data="filters"
                :enable-filters="false"
                context="suggestContext"
            ></filter-input-suggest>
        </div>

        <div
            class="h-full"
            :class="{ 'hidden lg:block' : ! showDestination, 'block' : showDestination}"
        >
            <div
                class="filter-country"
                :class="{ 'selected flex-shrink-0': selectedCountryString !== '' }"
                :data-filter-reference="filters.country.reference"
                :data-selected-value="selectedCountryString"
                v-if="showCountry"
            >
                <div
                    class="country-select"
                    :class="[getLocale(country.title), { 'active': country.selected }]"
                    v-for="country in filters.country.items"
                    @click.prevent="setCountry(country.reference, Object.values(filters.country.cancels)[0] ?? null)"
                >
                    <div class="title" :class="{ 'active': country.selected }">
                        <img
                            width="24"
                            height="16"
                            class="inline-block w-6 rounded-sm mr-3"
                            :src="'/assets/img/frontend-v3/flags/' + getLocale(country.title) + '.svg'"
                            :alt="getLocale(country.title)"
                            >
                        <div class="country-name">
                            {{ country.title }}
                        </div>

                        <small class="hidden xl:inline ml-1" v-html="'(' + country.count + ')'"></small>
                    </div>
                </div>

            </div>

            <div
                class="filter-destination"
                v-if="filters['province-region']"
                v-show="! arePlacesActive"
            >
                <div
                    class="flex-grow pr-1 pb-10 lg:pb-1 w-full border-r last:border-0"
                    v-for="(data, reference) in filters['province-region'].items"
                    :data-filter-reference="reference"
                    :data-selected-value="getSelected(data.category)"
                >
                    <div class="p-4 py-1 font-semibold bg-hh-grey-100">{{ reference }}</div>

                    <div class="flex flex-wrap">

                        <button
                            class="show-all flex w-full xl:w-1/4"
                            @click.prevent="emit('check-and-activate-filter-external', 'arrival')"
                        >
                            <span class="truncate ml-5 mr-4" v-html="translations['all-' + data.category + 's']"></span>
                        </button>

                        <button
                            class="flex w-full xl:w-1/4 checkmark truncate"
                            v-for="item in data.items"
                            :class="{ selected: item.selected, disabled: item.disabled }"
                            @click.prevent="setProvReg(data.category, item.reference, Object.values(data.cancels)[0] ?? null)"
                        >
                            {{ item.title }}
                        </button>
                    </div>
                </div>

            </div>

            <div
                class="filter-destination"
                v-if="filters['place']"
                v-show="arePlacesActive"
            >
                <div
                    class="flex-grow pr-1 pb-10 lg:pb-1"
                    :data-filter-reference="filters['place'].reference"
                    :data-selected-value="selectedPlaceString"
                >
                    <div class="p-4 py-1 font-semibold bg-hh-grey-100">{{ filters.place.reference }}</div>

                    <div class="flex flex-wrap">

                        <button
                            class="show-all flex w-1/2 xl:w-1/4"
                            @click.prevent="setAllPlaces"
                        >
                            <span class="truncate ml-5 mr-4" v-html="translations['all-places']"></span>
                        </button>

                        <button
                            class="w-1/2 xl:w-1/4 checkmark"
                            v-for="item in filters['place'].items"

                            :class="{ selected: item.selected, disabled: item.disabled, hide: item.hidden }"
                            @click.prevent="setPlace(item.reference, Object.values(filters.place.cancels)[0] ?? null)"
                        >
                            {{ item.title }}
                            <span class="count" v-html="item.count" v-if="false"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: "Destinations",

    props: ['filter-data', 'translations', 'suggest-context'],

    data() {
        return {
            selected: {
                'country': [],
                'province': [],
                'region': [],
                'place': [],
            },

            provRegReference: null,

            filters: null,

            showDestination: false,
            arePlacesActive: false,
            showCountry: true,
            isLoading: true,
        }
    },

    created() {
        this.filters = this.filterData;

        this.$nextTick(() => {
            this.initSelectedFilters();
        });
    },

    mounted() {
        this.Bus.on('clear-primary-filter', (reference) => {
            if (reference === 'destination') {
                if (this.selected.country.length > 0) {
                    this.setCountry(this.selected.country[0], Object.values(this.filters.country.cancels)[0] ?? null)
                }
            }
        });

        this.Bus.on('set-suggest-filters', () => {
            this.clear();
        });

        this.Bus.on('clear-input-suggest', () => {

            this.clear();

            this.$nextTick(() => {
                // this.Bus.emit('hide-destination');
            })
        });

        this.Bus.on('toggle-places', (value) => {
            this.arePlacesActive = value;
        });

        this.Bus.on('set-places-active', (value) => {
            this.arePlacesActive = value;
        });

        this.Bus.on('activate-destination', (reference) => {
            this.Bus.emit('show-destination');
        });

        this.Bus.on('deactivate-destination', (reference) => {
            //this.Bus.emit('hide-destination');
        });

        this.Bus.on('show-destination', (reference) => {
            this.showDestination = true;
        });

        this.Bus.on('hide-destination', (reference) => {
            this.showDestination = false;
        });

        this.Bus.on('open-destination-sub-filters', (reference) => {
            this.Bus.emit('show-destination');
        });

        this.Bus.on('close-destination-sub-filters', (reference) => {
            this.Bus.emit('hide-destination');
        });
    },

    watch: {
        filterData: function(newFilters, oldFilters) {
            this.filters = newFilters;
            this.initSelectedFilters();
        },
    },

    methods: {

        initSelectedFilters() {
            this.selected['country'] = this.getSelectedFromFilterData(this.filterData['country']);
            this.selected['province'] = this.getSelectedFromFilterData(this.filterData['province-region'], 'province');
            this.selected['region'] = this.getSelectedFromFilterData(this.filterData['province-region'], 'region');
            this.selected['place'] = this.getSelectedFromFilterData(this.filterData['place']);
        },

        getSelectedFromFilterData(filterData, targetKey = null) {

            const filtersToCheck = filterData?.selectedFilters ?? {};

            let selected = [];

            Object.entries(filtersToCheck).forEach(([key, filterToCheck]) => {
                if (targetKey === null || key === targetKey) {
                    if (Object.values(filterToCheck).length > 0) {
                        selected = selected.concat(Object.keys(filterToCheck));
                    }
                }
            });

            return selected;
        },

        setItem(target, reference) {

            if (! target.includes(reference)) {
                target.push(reference);
            } else {
                target = target.filter(item => item !== reference);
            }

            return target;
        },

        setCountry(reference, cancels) {

            const add = ! this.selected['country'].includes(reference);

            this.selected['country'] = [];
            this.Bus.emit('show-destination');

            this.Bus.emit('set-places-active', false);

            if (add) {
                this.selected['country'] = this.setItem(this.selected['country'], reference);
            } else {
                this.Bus.emit('clear-input-suggest');
            }

            this.$nextTick(() => {
                this.Bus.emit('filter-change', cancels);
            })
        },

        setProvReg(filterReference, reference, cancels) {

            this.selected[filterReference] = this.setItem(this.selected[filterReference], reference);
            this.Bus.emit('show-destination');

            this.$nextTick(() => {
                this.Bus.emit('filter-change', cancels);
            })
        },

        setPlace(reference, cancels) {
            this.selected['place'] = this.setItem(this.selected['place'], reference);
            this.Bus.emit('show-destination');

            this.$nextTick(() => {
                this.Bus.emit('filter-change', cancels);
            })
        },

        setAllPlaces() {
            this.selected['place'] = [];

            this.$nextTick(() => {
                this.Bus.emit('filter-change', Object.values(this.filters.place.cancels)[0] ?? null);
            })

            this.Bus.emit('check-and-activate-filter-external', 'arrival')
        },

        getSelected(reference) {
            return this.selected[reference]?.join(',');
        },

        getLocale(title) {
            return this.filters.country.options.flags[title];
        },

        togglePlaces() {
            this.arePlacesActive = ! this.arePlacesActive;

            this.Bus.emit('toggle-places', this.arePlacesActive);
        },

        clear() {
            this.selected = {
                'country': [],
                'province': [],
                'region': [],
                'place': [],
            };
        }
    },

    computed: {

        selectedCountryString() {
            return this.selected['country']?.join(',');
        },

        selectedPlaceString() {
            return this.selected['place']?.join(',');
        },

    },
}
</script>
